import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CustomDrawerHeader = ({ title, sub_title, onBack }) => {
  return (
    <AppBar position="static" sx={{ bgcolor: "#fff", boxShadow: 0 }}>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Box style={{ display: "flex", alignItems: "center" }}>
          {onBack && (
            <IconButton
              edge="start"
              onClick={onBack}
              sx={{ mr: 1, color: "#000" }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography variant="h6" component="div" color="#000">
            {title}
          </Typography>
        </Box>
        <Typography fontSize={14} component="div" color="#000">
          {sub_title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default CustomDrawerHeader;
